module.exports = __webpack_public_path__ + "img/preview-3.569c45d4.png";